<template>
<div style="height: 100%">
  <div class="subsidiary-order-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
    <!-- Tab切换 -->
    <div class="sub-tabs">
      <div class="sub-tab" :class="{ active: activeTab === 'unread' }" @click="switchTab('unread')">
        逾期未读 <span class="badge" v-if="unreadCount > 0">{{ unreadCount }}</span>
      </div>
      <div class="sub-tab" :class="{ active: activeTab === 'read' }" @click="switchTab('read')">
        逾期已读未反馈 <span class="badge" v-if="readCount > 0">{{ readCount }}</span>
      </div>
    </div>

    <!-- 列表 -->
    <div class="order-list" v-if="tableList.length > 0">
      <div class="order-block" v-for="(item, index) in tableList" :key="index" @click="goToDetail(item)">
        <div class="order-block-header">
          <div class="order-block-left">
            <div class="order-block-top">
              <span class="order-po-tag">PO</span>
              <span class="order-number">{{ item.customerpono || '' }}</span>
            </div>
            <div class="order-block-link">{{ item.bstkd || '' }}</div>
          </div>
          <div class="order-block-right">
            <span class="order-overdue">逾{{ item.overdueDay || 0 }}天</span>
            <span class="order-salesman">业务 <span class="highlight">{{ item.ywymc || '' }}</span></span>
          </div>
        </div>
        <div class="order-block-tags">
          <span class="order-meta-tag">{{ item.kunnrT || '' }}</span>
          <span class="order-meta-tag">{{ item.zmodel || '' }}</span>
        </div>
        <div class="order-block-info">
          <div class="order-info-row">
            <span class="info-label">订单金额</span>
            <span class="info-value orange"><span class="currency">&yen;</span>{{ formatAmount(item.dmbtr) }}</span>
          </div>
          <div class="order-info-row">
            <span class="info-label">售达方</span>
            <span class="info-value">{{ item.kunnrT || '' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <el-empty v-if="tableList.length === 0 && listsClose" description="暂无数据"></el-empty>

    <!-- 加载更多 -->
    <div class="scroll-more" v-if="loading">加载中...</div>
    <div class="scroll-more" v-if="tableList.length > 0 && listsClose">没有更多了</div>

    <!-- 批量催办按钮 -->
    <div class="batch-urge-bar" v-if="tableList.length > 0">
      <el-button size="small" class="batch-urge-btn" @click="batchUrge">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M22 17H2a3 3 0 003 3h14a3 3 0 003-3z"/><path d="M18 8V6a6 6 0 00-12 0v2H4v9h16V8h-2zM9 8V6a3 3 0 016 0v2"/></svg>
        批量催办
      </el-button>
    </div>
  </div>
</div>
</template>

<script>
import h5LoginMixin from './loginMixin';

export default {
  name: 'SubsidiaryOrderList',
  mixins: [h5LoginMixin],
  data() {
    return {
      activeTab: 'unread', // unread | read
      dataty: '', // 已送货未开票 | 已开票未回款
      principalId: '',
      tableList: [],
      paginationConf: {
        pageNum: 0,
        pageSize: 15,
        pageTotal: 0,
      },
      loading: false,
      listsClose: false,
      unreadCount: 0,
      readCount: 0,
    };
  },
  created() {
    this.dataty = this.$route.query.dataty || '已送货未开票';
    document.title = this.dataty;
  },
  methods: {
    onLoginSuccess() {
      this.principalId = this.$route.query.principalId || sessionStorage.getItem('UNAME') || '';
      // 确保 dataty 已设置（mixin created 可能先于组件 created 执行）
      if (!this.dataty) {
        this.dataty = this.$route.query.dataty || '已送货未开票';
        document.title = this.dataty;
      }
      this.query();
    },
    switchTab(tab) {
      this.activeTab = tab;
      this.query();
    },
    query() {
      this.tableList = [];
      this.paginationConf.pageNum = 0;
      this.loading = false;
      this.listsClose = false;
      this.loadMore();
    },
    // 加载列表数据/滑到底部自动加载
    loadMore() {
      if (this.listsClose) {
        return false;
      }
      this.loading = true;
      setTimeout(async () => {
        this.paginationConf.pageNum += 1;
        await this.init();
        this.loading = false;
      }, 200);
    },
    async init() {
      let readStatus = this.activeTab === 'unread' ? 0 : 1;
      let res = await this.$api.receivableSubsidiaryLeaderList({
        dataty: this.dataty,
        principalId: this.principalId,
        readStatus: readStatus,
        ...this.paginationConf,
      });
      if (res.code === 200 && res.result) {
        if (res.result.list) {
          this.tableList = this.tableList.concat(res.result.list);
        }
        this.paginationConf.pageTotal = res.result.totalCount;
        if (res.result.page >= res.result.totalPage) {
          this.listsClose = true;
        }
        // 首次加载时统计数量
        if (this.paginationConf.pageNum === 1) {
          if (readStatus === 0) {
            this.unreadCount = res.result.totalCount;
          } else {
            this.readCount = res.result.totalCount;
          }
        }
      } else {
        this.listsClose = true;
      }
    },
    goToDetail(item) {
      this.$router.push({
        path: '/RMS/H5/subsidiaryFeedback',
        query: {
          vbeln: item.vbeln,
          type: this.dataty === '已送货未开票' ? '1' : '2',
          isLeader: 'true',
          principalId: this.principalId,
        },
      });
    },
    async batchUrge() {
      try {
        let res = await this.$api.receivableBatchUrge({
          dataty: this.dataty,
          principalId: this.principalId,
        });
        if (res.code === 200) {
          this.$message.success('批量催办通知已发送');
        } else {
          this.$message.warning(res.message || '批量催办失败');
        }
      } catch (e) {
        this.$message.error('批量催办异常');
      }
    },
    formatAmount(val) {
      if (!val) return '0.00';
      return Number(val).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
};
</script>

<style lang="less" scoped>
.subsidiary-order-list {
  height: 100%;
  overflow-y: auto;
  background: #F5F6F7;
  padding-bottom: 80px;
}

.sub-tabs {
  display: flex;
  background: #FFFFFF;
  padding: 0 16px;
  gap: 20px;
  border-bottom: 0.5px solid #E5E5E5;
  position: sticky;
  top: 0;
  z-index: 10;
}
.sub-tab {
  padding: 12px 4px;
  font-size: 14px;
  color: #999;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  &.active {
    color: #111;
    font-weight: 600;
    &::after {
      content: '';
      position: absolute;
      bottom: 0; left: 0; right: 0;
      height: 3px;
      background: #07C160;
      border-radius: 2px 2px 0 0;
    }
  }
  .badge {
    background: #FA5151;
    color: #fff;
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 8px;
    font-weight: 600;
    min-width: 16px;
    text-align: center;
  }
}

.order-list { padding: 16px 12px; }
.order-block {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.order-block:active { opacity: 0.9; }
.order-block-header {
  display: flex; justify-content: space-between; align-items: stretch; margin-bottom: 4px;
}
.order-block-left {
  display: flex; flex-direction: column; gap: 4px; flex: 1; min-width: 0;
}
.order-block-top {
  display: flex; align-items: center; gap: 8px;
}
.order-block-link { font-size: 13px; color: #999; }
.order-block-right {
  display: flex; flex-direction: column; align-items: flex-end; gap: 2px;
  flex-shrink: 0; margin-left: 8px; align-self: flex-start;
}
.order-po-tag {
  font-size: 11px; font-weight: 600; color: #0052D9;
  background: rgba(0,82,217,0.12); padding: 2px 6px; border-radius: 4px;
}
.order-number {
  font-size: 16px; font-weight: 700; color: #111;
}
.order-overdue {
  font-size: 14px; font-weight: 600; color: #FA5151;
}
.order-salesman {
  font-size: 12px; color: #999;
  .highlight { color: #576B95; font-weight: 600; }
}
.order-block-tags {
  display: flex; gap: 8px; margin-bottom: 8px;
}
.order-meta-tag {
  font-size: 12px; color: #0052D9; background: rgba(0,82,217,0.08);
  padding: 3px 10px; border-radius: 6px; font-weight: 600;
}
.order-block-info {
  padding-top: 8px; border-top: 0.5px solid #F0F0F0;
}
.order-info-row {
  display: flex; justify-content: space-between; align-items: center; padding: 6px 0;
  .info-label { font-size: 14px; color: #666; font-weight: 500; }
  .info-value { font-size: 15px; font-weight: 600; color: #111; text-align: right; }
  .info-value.orange { font-size: 18px; font-weight: 700; color: #FF6B35; }
  .currency { font-size: 14px; font-weight: 500; color: #FF6B35; margin-right: 1px; }
}

.scroll-more { padding: 15px 0; text-align: center; font-size: 14px; color: #5e6d82; }

.batch-urge-bar {
  position: fixed; bottom: 0; left: 50%; transform: translateX(-50%);
  width: 100%; max-width: 750px; background: #FFFFFF;
  border-top: 0.5px solid #E5E5E5; z-index: 1000;
  padding: 8px 16px; box-shadow: 0 -2px 8px rgba(0,0,0,0.02);
  display: flex;
  justify-content: center;
  align-items: center;
}
.batch-urge-btn {
  width: 50%;
  height: 44px;
  background: #07C160;
  color: #fff;
  border: none; border-radius: 8px;
  font-size: 15px; font-weight: 600;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  box-shadow: 0 2px 8px rgba(7,193,96,0.25);
}
</style>
